import StarIcon from '@hc-frontend/core-icons/kit/star';
import StarHalfIcon from '@hc-frontend/core-icons/kit/star-half';
import StarOutlineIcon from '@hc-frontend/core-icons/kit/star-outline';

import type { RatingStarsProps } from './rating-stars.types';

export function RatingStars({
  value,
  maxValue = 5,
  size = 24,
  onChange,
}: RatingStarsProps) {
  const values = [1, 2, 3, 4, 5];
  const normalizedValue = (value * 5) / maxValue;

  const getIcon = (v: number) => {
    const result = normalizedValue - v + 1;

    if (result > 0 && result < 1) {
      return StarHalfIcon;
    }

    if (result > 0) {
      return StarIcon;
    }

    return StarOutlineIcon;
  };

  return (
    <span className="inline-flex" aria-label={normalizedValue.toString()}>
      {values.map((v) => {
        const Icon = getIcon(v);
        return (
          <Icon
            data-testid={`${v}-star`}
            key={v}
            width={size}
            height={size}
            className={`text-warning-800 ${onChange ? 'cursor-pointer' : ''}`}
            onClick={() => onChange?.(v)}
          />
        );
      })}
    </span>
  );
}
